export const PUBLIC_TENANT_ID = process.env.REACT_APP_PUBLIC_TENANT_ID
